import {
  IProduct,
  deleteIsLockInIdServiceable,
  setIsLockInIdServiceable,
  BACKUP_OFFER_KEY,
} from '@vfit/consumer/data-access';
import { getFromLocalStorageByKey } from '@vfit/shared/data-access';
import { IBackupOffer } from '@vfit/shared/models';
import { ICheckLockin } from '../../coverageToolModal.models';
import { LOCKIN_ERROR_CODES } from '../../coverageToolModal.utils';

const checkLockInOffer = (product: IProduct, lockInProduct?: IProduct): ICheckLockin => {
  const offeringServiceability = getFromLocalStorageByKey('offeringServiceability');
  const allOfferingIds: string[] = offeringServiceability?.offeringServiceabilityItem?.map(
    (el: IBackupOffer) => el.offering.id
  );
  const alternativeOffers = product?.alternativeProductOfferList || [];
  if (lockInProduct) {
    let isLockInIdServiceable = false;
    if (alternativeOffers?.length > 0 && lockInProduct?.cmsId) {
      isLockInIdServiceable = alternativeOffers?.includes(lockInProduct?.cmsId?.toString());
    }
    if (isLockInIdServiceable) {
      const offeringServiceabilityItem = offeringServiceability?.offeringServiceabilityItem?.find(
        (el: IBackupOffer) => el.offering.id?.toString() === lockInProduct?.offerId?.toString()
      );
      localStorage.setItem(
        BACKUP_OFFER_KEY,
        JSON.stringify({
          offeringId: offeringServiceabilityItem?.offering?.id?.toString(),
          cmsId: lockInProduct?.cmsId?.toString(),
        })
      );
      setIsLockInIdServiceable();
      return ICheckLockin.GO_TO_OFFER;
    }
    return ICheckLockin.NO_COVERAGE;
  }
  deleteIsLockInIdServiceable();
  let isOfferFound = false;
  alternativeOffers?.forEach((el) => {
    if (allOfferingIds?.includes(el)) isOfferFound = true;
  });
  if (isOfferFound) {
    return ICheckLockin.GO_TO_OFFER;
  }
  return ICheckLockin.NO_OFFER_FOUND;
};

export { checkLockInOffer, LOCKIN_ERROR_CODES };
